/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbound_Sync_InvoiceInputs */

const en_inbound_sync_invoice = /** @type {(inputs: Inbound_Sync_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supplier invoice to Business Central (I-24)`)
};

/**
* | output |
* | --- |
* | "Supplier invoice to Business Central (I-24)" |
*
* @param {Inbound_Sync_InvoiceInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_sync_invoice = /** @type {((inputs?: Inbound_Sync_InvoiceInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Sync_InvoiceInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_sync_invoice(inputs)
});